export function BMWIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 90.857 90.857"
      aria-hidden="true"
      {...props}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
        <g fillRule="nonzero">
          <g fill="none" fillRule="nonzero" stroke="none" strokeWidth={1}>
            <path
              fill="#0166b1"
              d="M42.204 26.5c0 8.679-7.025 15.704-15.704 15.704V26.5h15.704zM26.5 10.796V26.5H10.796c0-8.679 7.025-15.704 15.704-15.704z"
              transform="matrix(1.71429 0 0 1.71429 0 0)"
            />
          </g>
          <path
            fill="#fff"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
            d="M-19.433 9.03c8.678 0 15.703 7.025 15.703 15.703h-15.703V9.03zm-15.704 15.703h15.704v15.704c-8.679 0-15.704-7.025-15.704-15.704z"
            transform="matrix(1.71429 0 0 1.71429 78.743 3.029)"
          />
          <path
            d="M26.5 10.796v.861c8.183 0 14.843 6.658 14.843 14.843h.86c0-8.672-7.03-15.704-15.703-15.704m0 30.547c-8.183 0-14.843-6.658-14.843-14.843h-.86c0 8.672 7.03 15.704 15.703 15.704M26.5 0C11.865 0 0 11.865 0 26.5S11.865 53 26.5 53 53 41.135 53 26.5 41.135 0 26.5 0zm24.777 26.5c0 13.683-11.092 24.777-24.777 24.777S1.723 40.183 1.723 26.5c0-13.683 11.094-24.777 24.777-24.777 13.683 0 24.777 11.094 24.777 24.777z"
            fill="#6f6f6f"
            transform="scale(1.71429)"
          />
          <path
            d="M7.978 10.444c.847-.886 1.326-1.909.48-2.886-.461-.53-1.235-.646-1.876-.385l-.064.025.02-.056c.095-.252.156-1.056-.534-1.61-.336-.271-.758-.372-1.185-.328-.795.08-1.407.62-3.072 2.464A39.919 39.919 0 0 0 .073 9.67l4.575 4.31c1.516-1.666 2.134-2.286 3.33-3.537zM2.008 9.39c.922-1.12 1.9-2.135 2.344-2.537.14-.127.293-.253.478-.303.3-.082.61.13.68.436.07.308-.124.6-.34.841-.488.546-2.275 2.402-2.275 2.402l-.887-.84zM3.8 11.078s1.74-1.827 2.308-2.412c.226-.231.37-.372.526-.448.201-.097.42-.117.617.012.193.129.282.35.233.57-.057.26-.272.51-.45.7l-2.306 2.452-.928-.874Zm16.026-5.774 1.464-3.259.094-.289-.027.302.154 4.354a22.46 22.46 0 0 1 1.568.206L22.84.168C22.109.089 21.38.032 20.652 0L19.21 3.557l-.051.265-.052-.265L17.665 0c-.729.03-1.457.088-2.189.169l-.238 6.45a23.427 23.427 0 0 1 1.568-.207l.154-4.354-.027-.302.094.29 1.464 3.258h1.335zm12.165 6.742c.36.383.878 1.002 1.169 1.377l5.36-3.38a35.461 35.461 0 0 0-1.013-1.248l-3.395 2.229-.231.198.172-.25L35.553 8l-1.06-1.053-2.994 1.49-.252.17.2-.23 2.247-3.37c-.396-.334-.776-.64-1.26-1.01l-3.402 5.319c.43.329.999.813 1.362 1.142l3.203-1.65.206-.15-.151.203-1.661 3.185Z"
            transform="matrix(1.71429 0 0 1.71429 12.339 5.608)"
            fill="#6f6f6f"
          />
        </g>
      </g>
    </svg>
  )
}
